const INFO_POPUP_DISPLAYED_KEY = 'riseup.wasPredictedIncomeInfoPopupDisplayed';
export default {
  INFO_POPUP_DISPLAYED_KEY,
};
